import React, { HTMLAttributes, RefObject } from 'react'
import * as S from './styled'
import { InputPlaceholderLabelWrapper } from './styled'
import { Controller } from 'src/infastruct/effector-react-form'
import Cleave from 'cleave.js/react'

export enum InputType {
    default,
    mobile,
    date
}

interface InputFormDesktopProps {
    type?: string
    controller: Controller
    label: string
    dataInputName: string
    inputType?: InputType
    attributes?: HTMLAttributes<HTMLInputElement>
    inputRef?: RefObject<HTMLInputElement> | null
}

const InputLabelWrapper = ({ label, children }: { label: string; children: JSX.Element }) => {
    return (
        <S.Container>
            {children}
            <S.Label>{label}</S.Label>
        </S.Container>
    )
}

export const InputFormDesktop = ({
    controller,
    label,
    attributes,
    inputRef,
    dataInputName,
    inputType = InputType.default
}: InputFormDesktopProps) => {
    const { input, isShowError } = controller()
    if (label) {
        switch (inputType) {
            case InputType.mobile: {
                return (
                    <InputLabelWrapper label={label}>
                        {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                        {/* @ts-ignore */}
                        <S.StyledInputMask
                            {...attributes}
                            {...input}
                            data-input-from-name={dataInputName}
                            value={input.value || ''}
                            type="tel"
                            mask="+7(999) 999 99 99"
                            isValid={!isShowError}
                            inputRef={inputRef}
                            required
                        />
                    </InputLabelWrapper>
                )
            }
            default:
            case InputType.date:
                return (
                    <InputPlaceholderLabelWrapper isValid={!isShowError}>
                        <InputLabelWrapper label={label}>
                            <Cleave
                                {...attributes}
                                {...input}
                                value={input.value || ''}
                                type={'tel'}
                                options={{
                                    date: true,
                                    delimiter: '.',
                                    numericOnly: true,
                                    datePattern: ['d', 'm', 'Y']
                                }}
                            />
                        </InputLabelWrapper>
                    </InputPlaceholderLabelWrapper>
                )
            case InputType.default: {
                return (
                    <InputLabelWrapper label={label}>
                        <S.InputPlacholderLabel
                            data-input-from-name={dataInputName}
                            isValid={!isShowError}
                            {...attributes}
                            {...input}
                            value={input.value || ''}
                            ref={inputRef}
                        />
                    </InputLabelWrapper>
                )
            }
        }
    }
    return (
        <S.InputBase
            isValid={!isShowError}
            ref={inputRef}
            {...attributes}
            {...input}
            placeholderRaised={label}
            value={input.value || ''}
            data-input-from-name={dataInputName}
        />
    )
}
